import type { ReactNode, SVGProps } from "react";

export type IconName =
  | "plus"
  | "grid"
  | "close"
  | "check"
  | "image"
  | "upload-image"
  | "compare"
  | "arrow-right"
  | "expand"
  | "replace"
  | "crop"
  | "lock"
  | "unlock"
  | "logout"
  | "arrow-up"
  | "arrow-down"
  | "arrow-left"
  | "brush"
  | "credit-card"
  | "chevron-right"
  | "eraser"
  | "export"
  | "folder"
  | "help"
  | "inspect"
  | "mirror-horizontal"
  | "flip-vertical"
  | "moon"
  | "pan"
  | "perspective"
  | "redo"
  | "restore"
  | "rotate-left"
  | "rotate-right"
  | "spark"
  | "settings"
  | "adjustments"
  | "layers"
  | "palette"
  | "straighten"
  | "sun"
  | "undo"
  | "user";

const paths: Record<IconName, ReactNode> = {
  plus: <path d="M12 5v14M5 12h14" />,
  grid: <><rect x="4" y="4" width="6" height="6" rx="1" /><rect x="14" y="4" width="6" height="6" rx="1" /><rect x="4" y="14" width="6" height="6" rx="1" /><rect x="14" y="14" width="6" height="6" rx="1" /></>,
  close: <path d="m6 6 12 12M6 18 18 6" />,
  check: <path d="m5 12 4 4L19 6" />,
  image: <><rect x="3" y="3" width="18" height="18" rx="3" /><circle cx="8" cy="8" r="1.5" /><path d="m4 18 6-6 4 4 3-3 4 4" /></>,
  "upload-image": <><rect x="3" y="3" width="18" height="18" rx="3" /><circle cx="8" cy="8" r="1.5" /><path d="m4 18 5-5 3 3" /><path d="M16 18v-8m-3 3 3-3 3 3" /></>,
  compare: <><path d="M12 3v18" /><rect x="3" y="5" width="18" height="14" rx="2" /></>,
  "arrow-right": <path d="M4 12h16m-6-6 6 6-6 6" />,
  expand: <path d="M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5" />,
  replace: <><path d="M4 8h13l-3-3M20 16H7l3 3" /><path d="M20 10V5M4 14v5" /></>,
  crop: <><path d="M6 2v14a2 2 0 0 0 2 2h14" /><path d="M18 22V8a2 2 0 0 0-2-2H2" /></>,
  lock: <><rect x="5" y="10" width="14" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" /></>,
  unlock: <><rect x="5" y="10" width="14" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 7.5-2M12 14v3" /></>,
  logout: <><path d="M10 5H5v14h5M14 8l4 4-4 4M9 12h9" /></>,
  "arrow-up": <path d="M12 20V4m-6 6 6-6 6 6" />,
  "arrow-down": <path d="M12 4v16m-6-6 6 6 6-6" />,
  "arrow-left": <path d="m15 18-6-6 6-6" />,
  brush: <><path d="m14.6 4.2 5.2 5.2L9 20H4v-5Z" /><path d="m12 7 5 5" /></>,
  "credit-card": <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 10h18M7 15h3" /></>,
  "chevron-right": <path d="m9 18 6-6-6-6" />,
  eraser: <><path d="m7 21-4-4L15 5l6 6L11 21Z" /><path d="M17 17H7" /></>,
  export: <><path d="M12 3v12" /><path d="m7 10 5 5 5-5" /><path d="M5 21h14" /></>,
  folder: <path d="M3 6h7l2 2h9v11H3Z" />,
  help: <><circle cx="12" cy="12" r="9" /><path d="M9.5 9a2.5 2.5 0 1 1 3.7 2.2c-.8.5-1.2.9-1.2 1.8" /><path d="M12 17h.01" /></>,
  inspect: <><circle cx="10.5" cy="10.5" r="5.5" /><path d="m15 15 5 5" /></>,
  "mirror-horizontal": <><path d="M12 3v18" /><path d="M8 7v10H3Z" /><path d="M16 7v10h5Z" /></>,
  "flip-vertical": <><path d="M3 12h18" /><path d="M7 8h10V3Z" /><path d="M7 16h10v5Z" /></>,
  moon: <path d="M20 15.5A8 8 0 0 1 8.5 4 8.5 8.5 0 1 0 20 15.5Z" />,
  pan: <><path d="M7 11V7a1.5 1.5 0 0 1 3 0v3-5a1.5 1.5 0 0 1 3 0v5-4a1.5 1.5 0 0 1 3 0v5-2a1.5 1.5 0 0 1 3 0v5c0 4-3 7-7 7h-1c-2 0-3-.7-4-2l-3-5a1.5 1.5 0 0 1 2.5-1.6L8 14" /></>,
  perspective: <path d="m6.1 4.2 12 1.7a1 1 0 0 1 .9 1v10.2a1 1 0 0 1-.9 1l-12 1.7a1 1 0 0 1-1.1-1V5.2a1 1 0 0 1 1.1-1Z" />,
  redo: <><path d="m15 8 4-4v6h-6" /><path d="M19 10a7 7 0 1 0 1 5" /></>,
  restore: <><path d="M5 8h10a5 5 0 0 1 0 10h-3" /><path d="m8 5-3 3 3 3" /><path d="M9 15h6" /></>,
  "rotate-left": <path d="M20 11a8 8 0 1 0-.5 4M20 20v-5h-5" />,
  "rotate-right": <path d="M4 11a8 8 0 1 1 .5 4M4 20v-5h5" />,
  spark: <><path d="m12 3 1.2 4.8L18 9l-4.8 1.2L12 15l-1.2-4.8L6 9l4.8-1.2Z" /><path d="m18.5 15 .6 2.4 2.4.6-2.4.6-.6 2.4-.6-2.4-2.4-.6 2.4-.6Z" /></>,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.8 2.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6v.2h-4V21a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1L4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9A1.7 1.7 0 0 0 3 14H2.8v-4H3a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9L4.2 7 7 4.2l.1.1A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-1.6v-.2h4V3a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1L19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.6 1h.2v4H21a1.7 1.7 0 0 0-1.6 1Z" /></>,
  straighten: <><path d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2" /><path d="M7 12h10" /></>,
  adjustments: <><path d="M3 6h5m4 0h9M3 12h11m4 0h3M3 18h3m4 0h11" /><circle cx="10" cy="6" r="2" /><circle cx="16" cy="12" r="2" /><circle cx="8" cy="18" r="2" /></>,
  layers: <><path d="m12 3 9 5-9 5-9-5Z" /><path d="m3 12 9 5 9-5M3 16l9 5 9-5" /></>,
  palette: <><path d="M12 3a9 9 0 1 0 0 18h1a2 2 0 0 0 1.4-3.4 1.5 1.5 0 0 1 1.1-2.6H18a3 3 0 0 0 3-3 9 9 0 0 0-9-9Z" /><circle cx="7.5" cy="10" r=".75" /><circle cx="10" cy="6.5" r=".75" /><circle cx="14.5" cy="6.5" r=".75" /><circle cx="17" cy="10" r=".75" /></>,
  sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></>,
  undo: <><path d="m9 8-4-4v6h6" /><path d="M5 10a7 7 0 1 1-1 5" /></>,
  user: <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>,
};

interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
}

export function Icon({ name, ...props }: IconProps) {
  return (
    <svg className="icon" aria-hidden="true" fill="none" height="20" viewBox="0 0 24 24" width="20" {...props}>
      <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8">
        {paths[name]}
      </g>
    </svg>
  );
}
